import { ValuesOfCorrectTypeRule } from 'graphql';
import gql from 'graphql-tag';
import React from 'react';
import { Button, Form } from 'semantic-ui-react';
import { useMutation } from '@apollo/client';

import { useForm } from '../util/hooks';
import { FETCH_POSTS_QUERY } from '../util/graphql';

function PostForm(){
    const { values, onChange, onSubmit } = useForm(createPostCallback, {
        body:''
    });

    const [createPost, { error }] = useMutation(CREATE_POST_MUTATION, {
        variables: values,
        update(proxy, result){
            const data = proxy.readQuery({
                query: FETCH_POSTS_QUERY
            });
            let newData = [result.data.createPost, ...data.getPosts]; //update the cache with the new created post at the top of the post array
            proxy.writeQuery({ 
                query: FETCH_POSTS_QUERY, 
                data: {
                    ...data,
                    getPosts: {
                        newData
                    }
                } });
            values.body='';
        },
        onError(err){
            
        }
    });

    function createPostCallback(){
        createPost();
    }

    return (
        <>
            <Form onSubmit={onSubmit}>
                <h2>Create a post:</h2>
                <Form.Field>
                    <Form.Input
                        placeholder='Hi World!'
                        name='body'
                        onChange={onChange}
                        value={values.body}
                        error={error? true: false}
                    />
                    <Button type='submit' color='teal' style={{ marginBottom: 20 }}>
                        Submit
                    </Button>
                </Form.Field>
            </Form>
            {
                error && (
                    <div className="ui error message" style={{ marginBottom: 20, marginTop: 0 }}>
                        <ul className="list">
                            <li>{error.graphQLErrors[0].message}</li>
                        </ul>
                    </div>
                )
            }
        </>  
    );
}

const CREATE_POST_MUTATION = gql`
mutation createPost($body: String!){
    createPost(body: $body){
        id
        body
        createdAt
        username
        likes{
            id
            username
            createdAt
        }
        likeCount
        comments{
            id
            username
            body
            createdAt
        }
        commentCount
    }
}
`

export default PostForm;